<template>
  <v-btn-form :title="title" @close="cancel()" listable>
      <v-list two-line dense>
        <template v-for="item in this.filteredItems">
          <v-list-tile v-bind:key="getItemKey(item)" @click.stop="select(getItemKey(item))">
             <v-list-tile-content>
              <b>{{item.text}}</b>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon v-if="radio" v-show="cxt.check(getItemKey(item))">radio_button_checked</v-icon>
              <v-icon v-if="radio" v-show="cxt.uncheck(getItemKey(item))">radio_button_unchecked</v-icon>
              <v-icon v-if="!radio" v-show="cxt.check(getItemKey(item))">check_box</v-icon>
              <v-icon v-if="!radio" v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    <template #actions>
      <v-btn @click="ok">ОК</v-btn>
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import vBtnForm from '../common/BtnForm'
  
  // import depo from '.'

  export default {
    name: 'strategy-selector',
    components: {vBtnForm},
    data: () => ({
      cxt: null
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      selected: {
        type: Array,
        default: function () {
          return []
        }
      },
      items: {
        type: Array,
        default: function () {
          return []
        }
      },
      title: {
        type: String,
        default: 'Выберите документ'
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.mode = classes.modes.SELECT
      this.cxt = cxt
      if (this.selected != null) {
        this.selected.forEach(id => this.cxt.select(id))
      }
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        calcDialogScroll: 'calcDialogScroll'
      }),
      orderedItems () {
        // console.log('orderedItems', this.items)
        return this.items.sort((a, b) => formats.compareString(a.text, b.text))
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(item.text)
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      }
    },
    methods: {
      getItemKey (item) {
        return item.value
      },
      ok () {
        this.$emit('input', this.cxt.selected())
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.itemId = null
      },
      select (uid) {
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      }
    }
  }
</script>




// WEBPACK FOOTER //
// StrategySelector.vue?e17c8518